<template>
  <div class="nt-search-results">

    <div v-if="!loading && !filterBy && !filtering" class="nt-search-results__header-center welcome-msg">
      <slot name="labelWelcomeText">
        <div>Showing results for</div>
      </slot>
    </div>

    <!-- Header -->
    <div v-if="!!total && !loading" class="nt-search-results__header">
      <div class="nt-search-results__header-left">
        <div class="button-filter" @click="changeVisibilityFilter">
          <svg v-if="!filterIsOpen">
            <use xlink:href="#icon-slider"></use>
          </svg>
          <svg v-else>
            <use xlink:href="#icon-close"></use>
          </svg>

          <div class="text-button">
            <slot name="labelShowFilters">Show filters</slot>
          </div>
        </div>
      </div>

      <div v-if="filterBy" class="nt-search-results__header-center">
        <div class="filter-by"> 
          <slot name="labelFilterBy">
            <div>Showing results for</div>
          </slot>
          <div class="filterbytext">
            <b>
              <i>{{ filterBy }}</i>
            </b>
          </div>
        </div>
      </div>

      <div class="nt-search-results__header-right">
        <b>{{ total }}</b>
        <slot name="labelFilterResults">
          <span>results founded</span>
        </slot>
      </div>
    </div>

    <div v-if="!total && !loading" class="nt-search-results__noresults">
      <div v-if="filterBy">
        <slot name="labelNoResultsBy">
          <div>No results for</div>
        </slot>
        <div class="filterbytext">
          <b>
            <i>{{ filterBy }}</i>
          </b>
        </div>
      </div>
      <div v-else>
        <slot name="labelNoResults">XXXX</slot>
      </div>
      <div v-if="filtering" class="button" @click="clearFilters(true)">
        <slot name="labeButtonNoResults">
          Button here
        </slot>
      </div>
    </div>

    <!-- <div v-if="!loading" class="nt-search-results__header-center" :class="{ 'nt-search-results__header-center--nodata' : !total }">
      <div v-if="filterBy">
        <slot v-if="!!total" name="labelFilterBy">
          <div>Showing results for</div>
        </slot>
        <slot v-else name="labelNoResultsBy">
          <div>No results for</div>
        </slot>
        <div class="filterbytext">
          <b>
            <i>{{ filterBy }}</i>
          </b>
        </div>
      </div>
      <div v-if="!total & !filterBy">
        No results founded
      </div>
    </div>

    <div v-if="!total && !loading && filtering" style="display: flex; justify-content: center">
      <div class="button" @click="clearFilters(true)">
        <slot name="labeButtonNoResults">
          Button here
        </slot>
      </div>
    </div> -->
    <!-- Content -->

    <div class="nt-search-results__content"
        :class="{ 'nt-search-results__content--filtering' : filterIsOpen }">

      <!-- Filter -->
      <div v-if="!!total" class="nt-search-results__content-left">
        <slot name="filter"
          :data="data"
          :parameters="parameters"
          :onClick="changeVisibilityFilter"
          :changeTaxonomyFilter="changeTaxonomyFilter"
          :onCancelFilter="onCancelFilter"
          :_resetFilters="clearFilters"
          :_filtering="filtering"
          :filterIsOpen="filterIsOpen"
          :changeYear="onChangeYear"
          :changeorderby="onChangeOrderby"
          :changeMediaType="onChangeMediaType"
          :onChangeAuthor="onChangeAuthor">
        </slot>
      </div>

      <!-- List -->
      <div class="nt-search-results__content-right" @click="pushArticleToGTM">
        <slot name="result"
          :data="data"
          :typeview="typeView"
          :showPreview="showPreview">
        </slot>

        <div v-if="total" class="nt-search-results__footer">
          <nt-paginator :total="total" :pageSize="pageSize" :current="page" @paginate="scrollToTop"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable*/
import qs from "qs";
import _ from 'lodash'
import axios from "axios";
import uri from "../../../utils/uri";
import { mapActions, mapGetters } from "vuex";
import search from "../../../store/search";

export default {
  name: "nt-search-results",
  props: {
    urlData: {
      type: String,
      required: true
    },
    allLabel: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      tempParams: null,
      pageSize: 12,
      total: null,
      data: Object,
      loading: false,
      renewQuery: true,
      firstLoad: true,
      previousParameters: null,
      pendingGTM: false
    };
  },
  watch: {
    filterIsOpen(values) {
      this.tempParams = this.parameters
    },
    typeView(value) {
      uri.updateQuery({ typeview: value });
    },
    parameters(values) {
      this.changeData(values)
      // this.scrollToTop()
    }
  },
  created() {
    this.changeLoading(true)
    this.getParams()

    window.addEventListener('popstate', (event) => {
      this.renewQuery = false
      this.initialize(event.state)
    })
  },
  mounted() {
    // this.openFilter(this.filtering && !this.isOnMobile())
    this.openFilter(!this.isOnMobile())
    this.pushResetButtonToGTM()
  },
  computed: {
    ...mapGetters([
      "typeView",
      "parameters",
      'filterIsOpen',
      "page",
      "filtering"
    ]),
    filterBy() {
      const { querysearch } = this.parameters;
      return querysearch;
    }
  },
  methods: {
    ...mapActions([
      "changeFilters",
      "openFilter",
      "resetFilters",
      "changePage",
      "initialize",
      "changeYear",
      "changeLoading",
      "changeOrderBy",
      "changeAuthor",
      'changeParams',
      'changeMediaType'
    ]),
    showPreview(item) {
      this.$root.$emit("changeSearchPreview", item);
    },
    isOnMobile() {
      return (navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i)
      )
    },
    getData(value) {
      const self = this;

      this.loading = true;

      this.changeLoading(this.loading);

      axios.get(this.urlData, {
          params: value,
          paramsSerializer: params => {
            return qs.stringify(params);
          }
        })
        .then(response => {
          const { search } = response.data;
          self.data = search;
          self.total = search.resultsAll;

          this.loading = false;
          this.changeLoading(this.loading);
          this.updateLazyLoad();

           if (this.pendingGTM) {
            this.pushGTM();
            this.pendingGTM = false;
          }
        })
        .catch(() => {
          this.loading = false;
          this.changeLoading(this.loading)
        })
    },
    updateLazyLoad() {
      const items = document.querySelectorAll('.nt-search-results__content-right .lazyloaded')
      if (items) {
        _.each(items, (item) => {
          item.classList.remove('lazyloaded')
          setTimeout(() => {
            item.classList.add('lazyload')
          }, 500)
        })
      }
    },
    changeData(values) {
      this.getData(values)

      if (this.renewQuery) {
        uri.updateQuery(values)

        if (!this.firstLoad && this.haveFiltersChanged(this.previousParameters, values)) {
          this.pendingGTM = true
        }
      }
      this.previousParameters = _.cloneDeep(values)
      this.firstLoad = false
      this.renewQuery = true
    },
    getParams() {
      const {
        pagenumber,
        filtertopics,
        filtersubtopics,
        filtertags,
        filtercontenttypes,
        typeview,
        startyear,
        endyear,
        orderby,
        mediatype,
        author,
        searchType
      } = uri.getQuery()

      this.initialize({
        typeview: parseInt(typeview, 10),
        filtertopics: typeof filtertopics === 'string' ? [filtertopics] : filtertopics,
        filtersubtopics: typeof filtersubtopics === 'string' ? [filtersubtopics] : filtersubtopics,
        filtertags: typeof filtertags === 'string' ? [filtertags] : filtertags,
        filtercontenttypes: typeof filtercontenttypes === 'string' ? [filtercontenttypes] : filtercontenttypes,
        pagenumber: parseInt(pagenumber, 10),
        startyear: parseInt(startyear, 10),
        endyear: parseInt(endyear, 10),
        orderby: parseInt(orderby, 10),
        mediatype: mediatype,
        author: author,
        searchType: searchType
      });
    },
    onCancelFilter() {
      if (this.tempParams != this.parameters) {
        this.changeParams(this.tempParams)
      }
      this.openFilter()
    },
    changeVisibilityFilter() {
      this.openFilter()
    },
    changeTaxonomyFilter(param) {
      param.name = param.name.toLowerCase()
      this.changeFilters(param);
    },
    clearFilters(clearAll) {
      this.resetFilters({ all: clearAll });
    },
    scrollToTop() {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
    onChangeYear(values) {
      const { name, value } = values;
      this.changeYear({ [name]: value });
    },
    onChangeOrderby(values) {
      const { name, value } = values;
      this.changeOrderBy({ [name]: value });
    },
    onChangeMediaType(values) {
      const { name, value } = values;
      this.changeMediaType({ [name]: value });
    },
    onChangeAuthor(value) {
      this.changeAuthor({ author: value })
    },
    isOutbound(url) {
      try {
        const componentUrl = new URL(url)
        return componentUrl.host.replace('assets.', '') !== window.location.host
      } catch (error) {
        return false
      }
    },
    getText(array) {
      return (array && array.length > 0) ? array.map(item => item.Text).join(', ') : 'vazio'
    },
    haveFiltersChanged(prev, next) {
      if (!prev) return true;

      const keysToCompare = [
        "querysearch",
        "filtertopics",
        "filtersubtopics",
        "filtertags",
        "filtercontenttypes",
        "startyear",
        "endyear",
        "author",
        "orderby",
      ];

      for (const key of keysToCompare) {
          const prevVal = prev[key] || null
          const nextVal = next[key] || null

          if (Array.isArray(prevVal) || Array.isArray(nextVal)) {
            const prevArr = Array.isArray(prevVal) ? prevVal : []
            const nextArr = Array.isArray(nextVal) ? nextVal : []

            if (nextArr.length > prevArr.length) {
              return true
            }

            if (prevArr.length === 0 && nextArr.length > 0) {
              return true
            }
          } else {
            if ((prevVal === null || prevVal === "") && nextVal !== null && nextVal !== "") {
              return true
            }
          }
        }

      return false
    },
    pushGTM() {
      const { querysearch, filtertopics, filtersubtopics, filtertags, filtercontenttypes, pagenumber, startyear, endyear, author, orderby } = this.parameters

      const formatArrayToString = (array) => {
        if (Array.isArray(array)) {
          return array.filter(item => typeof item === 'string').join(', ');
        }
        return ''
      }

      const isEmpty = (value) => value === undefined || value === null || value === ''

      const getValueOrDefault = (value) => isEmpty(value) ? 'vazio' : value

      window.dataLayer.push({
        event: 'hub_filter',
        name: getValueOrDefault(querysearch), 
        filter_topics: getValueOrDefault(formatArrayToString(filtertopics)),
        filter_subtopics: getValueOrDefault(formatArrayToString(filtersubtopics)),
        filter_tags: getValueOrDefault(formatArrayToString(filtertags)),
        filter_contenttypes: getValueOrDefault(formatArrayToString(filtercontenttypes)),
        page_number: getValueOrDefault(pagenumber),
        start_year: getValueOrDefault(startyear),
        end_year: getValueOrDefault(endyear),
        filter_author: getValueOrDefault(author),
        order_by: getValueOrDefault(orderby),
        quantity: this.total
      })
    },
    pushResetButtonToGTM() {
      const interval = setInterval(() => {
        const getResetButton = document.querySelector('.category__action')
    
        if (getResetButton) {
          const resetButton = getResetButton.querySelector('span')
          resetButton.addEventListener('click', () => {
            window.dataLayer.push({
              event: 'click',
              section: 'hub',
              label: 'Reset Filters'
            })
          })

          clearInterval(interval)
        }
      }, 500)
    },
    pushArticleToGTM(event) {
      const { pagenumber } = this.parameters;
      const target = event.target.closest("a")
      if (!target) return

      const articleDiv = target.querySelector('div[id^="tag-search-card-"]')
      if (!articleDiv) return

      const rawId = articleDiv.getAttribute("id");
      const articleId = rawId ? rawId.replace("tag-search-card-", "") : ""
      const article = this.data.results.find((item) => item.Id === articleId)
      if (!article) return;

      const fallback = (value, fallbackText) => value || fallbackText
      const { Title, DateFormated, Url } = article

      const urlParams = new URLSearchParams(window.location.search)

      const parseFilterArrayFromURL = (prefix) => {
        const entries = Array.from(urlParams.entries())
        const filtered = entries
          .filter(([key]) => key.startsWith(`${prefix}[`))
          .map(([, value]) => value)

        return filtered.length ? filtered.join(", ") : "vazio"
      };

      const getSingleParam = (paramName) => {
        const value = urlParams.get(paramName)
        return value ? value : "vazio"
      }

      const hasActiveFilters = () => {
        return (
          parseFilterArrayFromURL("filtertopics") !== "vazio" ||
          parseFilterArrayFromURL("filtersubtopics") !== "vazio" ||
          parseFilterArrayFromURL("filtertags") !== "vazio" ||
          parseFilterArrayFromURL("filtercontenttypes") !== "vazio" ||
          getSingleParam("startyear") !== "vazio" ||
          getSingleParam("endyear") !== "vazio" ||
          getSingleParam("author") !== "vazio" ||
          getSingleParam("orderby") !== "vazio"
        )
      }

    const countActiveFilters = () => {
        let count = 0;
        if (parseFilterArrayFromURL("filtertopics") !== "vazio") count++
        if (parseFilterArrayFromURL("filtersubtopics") !== "vazio") count++
        if (parseFilterArrayFromURL("filtertags") !== "vazio") count++
        if (parseFilterArrayFromURL("filtercontenttypes") !== "vazio") count++
        if (getSingleParam("startyear") !== "vazio") count++
        if (getSingleParam("endyear") !== "vazio") count++
        if (getSingleParam("author") !== "vazio") count++
        if (getSingleParam("orderby") !== "vazio") count++
        return count
      }

      window.dataLayer.push({
        event: "article_click",
        label: fallback(Title, "vazio"),
        publication_date: fallback(DateFormated, "vazio"),
        outbound: this.isOutbound(Url),
        placement: (this.data.results.findIndex((item) => item.Id === articleId) + 1).toString(),
        page_number: pagenumber.toString(),
        start_year: getSingleParam("startyear"),
        end_year: getSingleParam("endyear"),
        filter_topics: parseFilterArrayFromURL("filtertopics"),
        filter_subtopics: parseFilterArrayFromURL("filtersubtopics"),
        filter_tags: parseFilterArrayFromURL("filtertags"),
        filter_authors: getSingleParam("author"),
        filter_contenttypes: parseFilterArrayFromURL("filtercontenttypes"),
        order_by: getSingleParam("orderby") === "1" ? "Most Recent" : "vazio",
        filtered_value: hasActiveFilters(),
        filters_active: countActiveFilters().toString()
      })
    }
  }
};
</script>
